module.exports = __webpack_public_path__ + "3e476916b873ea92b00485f0a7d76d48.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/common/header/images/logo.png
// module id = 62
// module chunks = 0 1 2